export default __webpack_public_path__ + "./fonts/greenStar.751d869e.svg";